import styled from "styled-components";
import BackgroundImage from "../../../../Assets/bg/blurbg.png";
import { Container } from "../../../../Components/Common";

export const ExpandIcon = styled.img`
  width: 20px;
  height: 15px;
`;

export const FAQContainer = styled(Container)`
  @media screen and (max-width: 1120px) {
    width: 90%;
  }
`;

export const FAQPoints = styled.div`
  display: flex;
  width: ${(props) => props.width || "100%"};
  @media screen and (max-width: 768px) {
    width: 90%;
    justify-content: center;
  }
  align-items: baseline;
  h4 {
    font-weight: bold;
    @media screen and (max-width: 1400px) {
      font-size: 1.3rem;
    }
    @media screen and (max-width: 1024px) {
      font-size: 1.1rem;
    }
  }
`;

export const ShopifyImageWrapper = styled.div`
  width: 25%;
  min-width : 150px ; 
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ShopifyImage = styled.img`
  width: 150px;
  height: 70px;
  object-fit: cover;
`;

export const BlurbackgroundContainer = styled.div`
  background: url(${BackgroundImage}) no-repeat;
  background-image: url(${BackgroundImage}) ; 
  max-height : 80vh;
  overflow : hidden ; 
  @media screen and (max-width : 768px ){
    max-height: 100vh;
  }
`;

export const SecondBlurContainer = styled.div`
  background: rgba(
    255,
    255,
    255,
    0.1
  ); // Make sure this color has an opacity of less than 1
  backdrop-filter: blur(50px); // This be the blur
`;